import * as React from 'react'

export default () => <h1>No Encontrado</h1>
